"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _genericPopupThemes = _interopRequireDefault(require("./generic-popup-themes"));

var _genericPopupTheme = _interopRequireDefault(require("./generic-popup-theme.shape"));

const MODALS_ZINDEX = '2147483647';

const GenericPopup = props => {
  const {
    onClose,
    hasClose,
    children,
    hasHeader,
    headerText,
    className,
    theme,
    container
  } = props; // creates the modals element in case it doesn't exist in the DOM

  let modals = document.getElementById(container);

  if (!modals) {
    modals = document.createElement('div');
    modals.setAttribute('id', container);
    document.body.prepend(modals);
  }

  (0, _react.useEffect)(() => {
    GenericPopup.count++;
    modals.style.zIndex = MODALS_ZINDEX;
    return () => {
      GenericPopup.count--;

      if (GenericPopup.count < 1) {
        modals.style.zIndex = '';
      }
    };
  }, []);
  return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('generic-popup__overlay', "generic-popup__overlay--".concat(theme)),
    onClick: onClose
  }), modals), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('generic-popup', "generic-popup--".concat(theme), {
      'generic-popup--header': hasHeader
    }, className)
  }, hasClose && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('generic-popup__close-btn', "generic-popup__close-btn--".concat(theme)),
    onClick: onClose
  }), hasHeader && /*#__PURE__*/_react.default.createElement("div", {
    className: "generic-popup__header"
  }, headerText && headerText), /*#__PURE__*/_react.default.createElement("div", {
    className: "generic-popup__content"
  }, children))), modals);
};

GenericPopup.count = 0;
GenericPopup.propTypes = {
  onClose: _propTypes.default.func,
  hasClose: _propTypes.default.bool,
  children: _propTypes.default.node.isRequired,
  hasHeader: _propTypes.default.bool,
  headerText: _propTypes.default.string,
  className: _propTypes.default.string,
  theme: _genericPopupTheme.default,
  container: _propTypes.default.string
};
GenericPopup.defaultProps = {
  onClose: () => {},
  hasClose: true,
  hasHeader: false,
  headerText: null,
  className: '',
  theme: _genericPopupThemes.default.DARK,
  container: 'modals'
};
var _default = GenericPopup;
exports.default = _default;